import { ReactNode } from 'react';
import cx from 'classnames';

import styles from '../IncodeSdkPage.scss';

export const IncodeFooter = ({ children, className }: { children: ReactNode; className?: string }) => (
  <footer className={cx(styles.footer, className)}>
    <div className={styles.content}>{children}</div>
  </footer>
);
